import { State, AppState, STORE_KEY } from './slice';

export const selectCampaignId = (state: State): AppState['campaignId'] =>
  state[STORE_KEY].campaignId;

export const selectTitle = (state: State): AppState['title'] => state[STORE_KEY].title;
